import { UserTreatmentWithTreatmentName } from './UserTreatmentWithTreatmentName'
import { emptyUserTreatmentDTO, UserTreatmentDTO } from './UserTreatmentDTO'

export interface UserTreatmentWithTreatmentNameDTO {
  userTreatment: UserTreatmentDTO
  name: string
  dose?: number
  unit?: number
}

export function emptyUserTreatmentWithTreatmentNameDTO(): UserTreatmentWithTreatmentNameDTO {
  return {
    userTreatment: emptyUserTreatmentDTO(''),
    name: '',
    dose: 0,
    unit: 0,
  }
}

export function fromModel(t: UserTreatmentWithTreatmentName): UserTreatmentWithTreatmentNameDTO {
  return {
    userTreatment: t.userTreatment,
    name: t.name,
    dose: t.dose,
    unit: t.unit,
  }
}

export function toModel(d: UserTreatmentWithTreatmentNameDTO): UserTreatmentWithTreatmentName {
  return new UserTreatmentWithTreatmentName(d)
}
